import '../ViewNFT.css'
import { useEffect, useState } from "react"
import Loading from "../../../components/Loading";

function NFTinfluencer() {
    return (
        <div>
            <ul>
                <li>Eminem</li>
                <li>Justin Bieber</li>
                <li>Neymar Junior</li>
                <li>Mark Cuban</li>
                <li>Jimmy Fallon</li>
                <li>Snoop Dogg</li>
                <li>Lil Baby</li>
                <li>Post Malone</li>
                <li>Kevin Hart</li>
                <li>Tom Brady</li>
                <li>Logan Paul</li>
            </ul>
        </div>
    )
}

export default NFTinfluencer;